import script from "./FullScreenHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullScreenHeader.vue?vue&type=script&setup=true&lang=ts"

import "./FullScreenHeader.vue?vue&type=style&index=0&id=06be5850&scoped=true&lang=css"

import exportComponent from "/node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06be5850"]])

export default __exports__